import classes from './style/services.module.css'
import Card from './Card'
import img from '../img/wave.svg'
import img1 from '../img/full.jpg'
import img2 from '../img/devOps.jpg'
import img3 from '../img/Cloud.jpg'

const Services = () => {
    return (
        <div className={classes.servicesCont}>
            <h1 className='title'>
                Services
            </h1>
            <p className='subTitle color2'>
                <span className='subTitleBefore'> /* </span>
                Tech. positions
                <span className='subTitleAfter'> */ </span>
            </p>
            <div className={classes.cardsContainer}>
                <Card img={img1} title='Full Stack Developmen' content='End-to-end web development with frontend and backend expertise.' />
                <Card img={img2} title='DevOps Implementation' content='Implementing DevOps practices for streamlined software development and deployment.' />
                <Card img={img3} title='Cloud Infrastructure Management' content='Managing cloud infrastructure for scalable and secure deployments.' />

            </div>

            <div className='wave'>
                <img src={img} alt="wave" />
            </div>

        </div>
    )
}

export default Services
